/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_TitleInputs */

const en_sorter_ref_title = /** @type {(inputs: Sorter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How key pairs actually order`)
};

const ko_sorter_ref_title = /** @type {(inputs: Sorter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키 쌍이 실제로 정렬되는 방식`)
};

const ja_sorter_ref_title = /** @type {(inputs: Sorter_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーの組が実際に並ぶ順序`)
};

/**
* | output |
* | --- |
* | "How key pairs actually order" |
*
* @param {Sorter_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_title = /** @type {((inputs?: Sorter_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_title(inputs)
	if (locale === "ko") return ko_sorter_ref_title(inputs)
	return ja_sorter_ref_title(inputs)
});